import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  error: false
};

const UserDeleteSlice = createSlice({
  name: "UserDelete",
  initialState,
  reducers: {
    userDeleteSuccess(state) {
      state.success = true;
    },
    userDeleteError(state, action) {
      state.error = true;
    },
    userDeleteReset(state) {
      state.success = false;
      state.error = false;
    }
  },
});

export const {
  userDeleteSuccess,
  userDeleteError,
  userDeleteReset
} = UserDeleteSlice.actions

export default UserDeleteSlice.reducer;
